<section class="header"
         fxLayout="row"
         fxLayoutAlign="space-between center">

  <div fxLayout="row"
       fxLayoutAlign="center center"
       [ngClass.gt-xs]="'ml-5'"
       [ngClass.xs]="'ml-2'">

    <mat-icon class="menu__icon"
              *ngIf="!isStudant"
              (click)="openMenu()">menu</mat-icon>
    <div class="ml-2 header__company-name"
         fxHide.xs>SINDAUTO</div>

  </div>

  <div fxLayout="row">

    <div fxLayout="row"
         fxLayoutAlign="center center">

      <app-notifications class="mr-2" *ngIf="!isStudant"></app-notifications>

      <div class="header__perfil hover"
           matTooltipPosition="above"
           [matTooltip]="roles.length > 1 ? 'Clique sobre o nome do perfil para poder alterar' : ''">
        <mat-label class="header__perfil-label" *ngIf="!isStudant">
          <span> PERFIL </span>
          <span *ngIf="roles.length > 1">(clique sobre o nome para alterar)</span>
        </mat-label>
        <mat-select [formControl]="roleSelect" *ngIf="!isStudant">
          <mat-option  [value]="role"
                      *ngFor="let role of roles">
            {{role.name}}
          </mat-option>
        </mat-select>
      </div>

      <div class="header__dados"
           matTooltipPosition="above"
           fxLayout="row"
           [matTooltip]="'Menu'"
           (click)="showMenu()">
        <mat-icon color="white"
                  class="mr-2">account_circle</mat-icon>
        <span>{{firstName}}</span>
      </div>
    </div>

    <!-- <div class="header__teleclass pl-2"
         fxLayout="row"
         fxLayoutAlign="space-between center"
         fxHide.xs
         (click)="accessTeleClass()">
      <div fxLayout="column"
           fxLayoutAlign="start start">
        <span class="header__teleclass-access">Acessar</span>
        <span class="header__teleclass-text">Portal de Serviços</span>
      </div>
      <mat-icon class="header__teleclass-arrow">arrow_upward</mat-icon>
    </div> -->
  </div>

  <div #menu
       class="menu"
       id="menu"
       (click)="closeMenu($event)">

    <div #menuBox
         class="menu__box"
         id="menu-box">

      <div class="menu--relative menu--header"
           fxLayout="row"
           fxLayoutAlign="space-between center">

        <span fxLayout="row"
              fxLayoutAlign="center center"
              ngClass.gt-xs="ml-5"
              ngClass.xs="py-3">

          <mat-icon class="menu__icon"
                    (click)="closeMenu()">close</mat-icon>
          <div class="ml-2 header__company-name"
               fxHide.xs>SINDAUTO</div>
          <span fxHide.gt-xs
                class="ml-4">Menu de opções</span>
        </span>

        <span fxLayout="row"
              fxLayoutAlign="center center"
              class="mr-5"
              fxHide.xs>

          <div class="mr-2">
            <div>{{user?.name}}</div>
            <div>CPF: {{user?.userName | cpfPipe}}</div>
          </div>

          <button mat-flat-button
                  color="primary"
                  (click)="logout()"
                  [matTooltip]="'Sair'"
                  matTooltipPosition="above">
            <img src="../../../../assets/images/svg/logout.svg" />
          </button>

        </span>

      </div>

      <div #menuRelative
           class="menu--relative menu-items"
           fxLayout="row"
           fxLayout.xs="column"
           [ngClass]="{'menu-items-ajuste': menuItems.length <= 3 }"
           [ngClass.gt-xs]="'px-5'">

        <div *ngFor="let item of menuItems"
             class="menu__item"
             [id]="item.id"
             [ngClass]="{'menu__item-ajuste': menuItems.length <= 3 }"
             [ngClass.xs]="'menu__item-mobile pt-2'"
             [ngClass.gt-xs]="'mt-3'"
             (click)="expandMenu(item.id)">

          <div fxLayout="row">
            <mat-icon class="menu__item-icon mr-2">{{item?.icon}}</mat-icon>
            <div class="menu__item-title">{{item?.name}}</div>
          </div>

          <div *ngFor="let submenu of item?.submenus"
               ngClass.gt-xs="mt-2"
               ngClass.xs="ml-4 mt-2">
            <a *ngIf="!submenu?.type"
               class="menu__submenu"
               routerLinkActive="menu__item-active"
               [routerLink]="[submenu?.route]"
               [routerLinkActiveOptions]="{exact: true}"
               (click)="closeMenu()">{{submenu?.name}}</a>
            <a *ngIf="submenu?.type == 'external'"
               class="menu__submenu"
               target="_blank"
               [href]="submenu?.route"
               (click)="closeMenu()">{{submenu?.name}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--menu-->
  </div>
</section>

<app-menu-button [show]="show"></app-menu-button>

<div>
  <app-loading></app-loading>
</div>
